import { NgModule } from '@angular/core';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { RoutesModule } from './routes.module';
import { SharedModule } from './shared/shared.module';
import { provideToastr, ToastrModule } from 'ngx-toastr';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { DefaultLayoutComponent, TimeoutDialog } from '../app/layout/default-layout/default-layout.component';
import { SidebarComponent } from '../app/layout/sidebar/sidebar.component';
import { NavbarComponent } from '../app/layout/navbar/navbar.component';
import { FooterComponent } from '../app/layout/footer/footer.component';
import { TranslateComponent } from '../app/layout/widgets/translate.component';

import { environment } from '@env/environment';
import { DatePipe } from '@angular/common';
import { CdkColumnDef } from '@angular/cdk/table';
import { Idle } from '@ng-idle/core';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalBroadcastService, MsalGuard, MsalGuardConfiguration, MsalInterceptor, MsalInterceptorConfiguration, MsalService } from '@azure/msal-angular';
import { InteractionType, IPublicClientApplication, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { loginRequest, msalConfig, protectedResources } from '@shared/auth/auth-config';
import { BASE_URL } from '@core/interceptors/base-url-interceptor';
import { httpInterceptorProviders } from '@shared/core';
import { appInitializerProviders } from '@shared/core/initializers';
import { ApplicationReportComponent } from './components/reports/applicationReport/applicationReport.component';
import { TechnologyReportComponent } from './components/reports/technologyReport/technologyReport.component';
import { FoaReportComponent } from './components/reports/foaReport/foaReport.component';
import { InspectionSummaryReportComponent } from './components/reports/inspectionSummaryReport/inspectionSummaryReport.component';
import { ApplicationFeesReportComponent } from './components/reports/applicationFeesReport/applicationFeesReport.component';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { PtFailedReportComponent } from './components/reports/ptFailedReport/ptFailedReport.component';
import { PtPassedReportComponent } from './components/reports/ptPassedReport/ptPassedReport.component';
import { PtSearchReportComponent } from './components/reports/ptSearchReport/ptSearchReport.component';
import { CertificateReportComponent } from './components/reports/certificateReport/certificateReport.component';
import { AttachedReportComponent } from './components/reports/attachedReport/attachedReport.component';
import { AttachedReportFooterComponent } from './components/reports/attachedReport/attachedReportFooter.component';
import { AttachedReportHeaderComponent } from './components/reports/attachedReport/attachedReportHeader.component';


const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}

export function MSALInstanceFactory(): IPublicClientApplication {
  let msal = new PublicClientApplication(msalConfig);
  return msal;
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(protectedResources.endpoint, protectedResources.scopes);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
    return {
      interactionType: InteractionType.Redirect,
      authRequest: loginRequest
    };
}
// Required for AOT compilation
export function TranslateHttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
@NgModule({
  declarations: [
    AppComponent,
    DefaultLayoutComponent,
    TimeoutDialog,
    SidebarComponent,
    NavbarComponent,
    FooterComponent,
    ApplicationReportComponent,
    TechnologyReportComponent,
    FoaReportComponent,
    InspectionSummaryReportComponent,
    ApplicationFeesReportComponent,
    PtFailedReportComponent,
    PtPassedReportComponent,
    PtSearchReportComponent,
    AttachedReportComponent,
    AttachedReportHeaderComponent,
    AttachedReportFooterComponent,
    CertificateReportComponent,
    TranslateComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RoutesModule,
    SharedModule,
    PDFExportModule,
    ToastrModule.forRoot(),
    NgIdleKeepaliveModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: TranslateHttpLoaderFactory,
        deps: [HttpClient],
      },
    })
  ],
  providers: [
    provideAnimations(),
    provideToastr(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalService,
    MsalGuard,
    DatePipe,
    // OrelapService,
    MsalBroadcastService,
    { provide: BASE_URL, useValue: environment.baseUrl },
    httpInterceptorProviders,
    appInitializerProviders,
    Idle,
    DatePipe,
    CdkColumnDef
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
